import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import {ICycleDuration, ICycleModel} from "../models";

import Duration from "@shared/sop/Duration";
import {intl2Num, intl2Str} from "@translate/T";

interface ICycleProps {
    intl: IntlShape;
    cycle: ICycleModel;
    duration: ICycleDuration;

    hasRotation: boolean;
    hasLightFactor: boolean;
    hasTilt: boolean;
    hasTemp: boolean;
}

class Cycle extends React.PureComponent<ICycleProps> {
    public render() {
        const {
            cycle,
            duration,
            intl,
            hasRotation,
            hasLightFactor,
            hasTilt,
            hasTemp,
        } = this.props;
        const {interval, level, temperature} = cycle;

        return (
            <tr>
                <td>
                    <Duration seconds={duration.startTime} />
                </td>
                <td>{intl2Num(intl, cycle.profiles, 0)}</td>
                <td>
                    {intl2Str(intl, "{interval} s", {
                        interval: intl2Num(intl, interval, 0),
                    })}
                </td>
                {hasRotation && (
                    <td>
                        {intl2Str(intl, "{level} rpm", {
                            level: intl2Num(intl, level, 0),
                        })}
                    </td>
                )}
                {hasTilt && (
                    <td>
                        {intl2Str(intl, "{level}°", {
                            level: intl2Num(intl, level, 0),
                        })}
                    </td>
                )}
                {hasLightFactor && (
                    <td>{intl2Num(intl, cycle.lightFactor, 2)}</td>
                )}
                {hasTemp && (
                    <td>
                        {intl2Str(intl, "{temperature} °C", {
                            temperature: intl2Num(intl, temperature, 0),
                        })}
                    </td>
                )}
                <td>
                    <Duration seconds={duration.duration} />
                </td>
            </tr>
        );
    }
}

export default injectIntl(Cycle);
